import axios from 'axios'
import { backendLink } from '@/main'
import type { FormInfo, ApiResponse, FormIndex, DataFile } from '@/interfaces'

export class FormWrapper<T> {

    private readonly route: string;

    constructor(route: string) {
        this.route = `${backendLink}/${route}`;
    }

    async getInfo(): Promise<FormInfo> {
        return this.callToApi<FormInfo>("info.php");
    }

    async getFormsWithStats(): Promise<FormIndex<T>> {
        return this.callToApi<FormIndex<T>>("index.php");
    }

    async getForms(): Promise<T[]> {
        return this.callToApi<T[]>("index.php");
    }

    async getForm(id: string|string[], key: string = "id"): Promise<T> {
        return this.callToApi<T>(`view.php?${key}=${id}`);
    }

    async addForm(data: DataFile): Promise<ApiResponse> {
        return this.postToApi("add.php", data, { headers: { 'content-type': 'multipart/form-data' } });
    }

    async addInvoice(id: string|string[], data: DataFile, type: string): Promise<ApiResponse> {
        return this.postToApi(`invoice/${type}.php?id=${id}`, data, { headers: { 'content-type': 'multipart/form-data' } });
    }

    async editForm(id: string|string[], data: DataFile, key: string = "id"): Promise<ApiResponse> {
        return this.postToApi(`edit.php?${key}=${id}`, data, {});
    }

    private async postToApi(route: string, data: DataFile, headers: any): Promise<ApiResponse> {
        const response = await axios.post(`${this.route}/${route}`, data, headers);

        return response?.data;
    }

    private async callToApi<T>(route: string): Promise<T> {
        const response = await axios.get(`${this.route}/${route}`);

        return response?.data;
    }
}